var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTrustlyWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 250",
    style: {
      enableBackground: "new 0 0 750 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M275.1,175V92.9h-29.6V75h78.7v18h-29.6V175H275.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,175v-72.7h18.1v11.5c4.7-9.7,10.6-11.5,16.9-11.5h7.1v18.2h-6.2c-9.2,0-17.3,5.3-17.3,21.4v33H322z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.4,148.7v-46.3H393v41.9c0,9.3,4.8,15.5,13.3,15.5c8.2,0,14.3-6.2,14.3-15.4v-42.1h18.6V175h-18v-9.2 c-4.7,7.3-11.9,10.8-21,10.8C384.9,176.7,374.4,166.4,374.4,148.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.1,154.5l16.4-3.7c0.8,6.4,6,10.7,14.7,10.7c7.1,0,11.2-3,11.2-6.9c0-3.2-1.9-5.3-8.8-7l-11.8-2.7 c-13.8-3.2-20.3-9.7-20.3-21.8c0-12.3,10.3-22.1,29.1-22.1c19.9,0,28.1,11.8,29.2,20.3l-16.4,3.6c-0.8-4.5-4.2-9.3-13.2-9.3 c-5.9,0-10.3,2.7-10.3,6.6c0,3.4,2.6,5.3,6.6,6.3l16,3.8c12.5,3,18.5,10.3,18.5,21c0,11.7-9.5,23.2-29.7,23.2 C458.3,176.4,450.1,163.4,449.1,154.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.3,175c-12.5,0-20.4-7.1-20.4-20.4v-36.1h-12.1v-16.2h12.1V85.8l18.6-5.3v21.9h14.8v16.2h-14.8v32.9 c0,5.3,2.6,7.4,8,7.4h8.1V175H548.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.8,175V75h18.6V175H574.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655,102.4h20l-30.7,98.7h-20l8.5-26h-10.1l-20.7-72.7h20l15.8,57.2L655,102.4z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "75,118.8 121.7,118.8 121.7,81.6 158.9,118.8 121.7,156 121.7,175 166.8,175 166.8,118.8 208.3,118.8 208.3,75  75,75  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrustlyWhite);
export default __webpack_public_path__ + "static/media/icon-trustly-white.46c911b00e55969f88b28925c37e2053.svg";
export { ForwardRef as ReactComponent };